import React, { useState, useEffect, useRef } from "react";
import CircularText from "./CircularText";

export const Skill = ({ className }) => { 
  const data = [
    {
      title: "Every Day Is A New Challenge",
      para: "I am Dinh Luong Ta. I am a programmer skilled in Software Development, including Web, Android and Application Development.",
      para1: "With technology continuing to evolve at an unprecedented speed, I would like to develop innovative solutions that have beneficial and significant impacts on the world.",
    }
  ];

  return (
    <section className={`skill ${className}`}>
      <div className="container">
        <div className="heading">
          <div className="animated-text bottomMargin-1"></div>
        </div>
        <div className="content flex-2-cols">

          <div className="lef mtop">
            {data.map((val, index) => (
              <div key={index}>
                <h1 className="animated-text">{val.title}</h1>
                <p>{val.para}</p>
                <p>{val.para1}</p>

                <button className="primary-btn btn-led">
                  Contact Me
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span className="line2"></span>
                  <span className="line2"></span>
                  <span className="line2"></span>
                  <span className="line2"></span>
                </button>
              </div>
            ))}
          </div>

          <div className="right">
            <CircularText />
          </div>

        </div>
        <div className="timeline-section">
          <div className="timeline">
            {[
              {
                year: "2021",
                title: "Started learning HTML/CSS",
                desc: "Strengthened my understanding of web structure and design fundamentals.",
              },
              {
                year: "2022",
                title: "Learned JavaScript",
                desc: "Developed logical thinking and interactive effects.",
              },
              {
                year: "2023",
                title: "Built React JS Applications",
                desc: "Developed responsive and performant websites using React JS.",
              },
              {
                year: "2024",
                title: "Advanced Software Development",
                desc: "Worked on intelligent and advanced software solutions.",
              },
            ].map((item, i) => (
              <div className="timeline-item" key={i}>
                <div className="timeline-dot"></div>
                <div className="timeline-content">
                  <h4>{item.year} - {item.title}</h4>
                  <p>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};